import { Text } from '@a0/quantum-product';
import * as React from 'react';
import parse from 'url-parse';
import { Breadcrumbs } from '../../../Breadcrumbs';
import { NavLink } from '../../../NavLink';
export var SearchResult = function (_a) {
    var title = _a.title, url = _a.url, content = _a.content, description = _a.description, crumbs = _a.crumbs, onClick = _a.onClick;
    var contentBody = description || content;
    var path = parse(url).pathname;
    return (React.createElement("div", { onClick: onClick },
        React.createElement(NavLink, { variant: "h5", href: path }, title),
        crumbs && React.createElement(Breadcrumbs, { crumbs: crumbs }),
        contentBody && React.createElement(Text, { variant: "body2", color: "textSecondary", dangerouslySetInnerHTML: { __html: contentBody } })));
};
